module.exports = __webpack_public_path__ + "img/linkedin-logo-gray.0c895b04.svg";